import { useEffect, useMemo, useState } from "react";
import "./App.css";
import profileData from "./data/profileData";
import { createIntroMessage, generateResponse } from "./lib/chatResponder";

const quickQuestions = [
  "Tell me about your experience",
  "What projects have you built?",
  "What are your core skills?",
  "How can I contact you?"
];

function App() {
  const [input, setInput] = useState("");
  const initialMessages = useMemo(
    () => [
      {
        id: 1,
        role: "assistant",
        content: createIntroMessage(profileData)
      }
    ],
    []
  );
  const [messages, setMessages] = useState(initialMessages);

  useEffect(() => {
    document.title = `${profileData.name} | Portfolio`;
  }, []);

  const sendQuestion = (question) => {
    const prompt = question.trim();
    if (!prompt) return;

    const userMessage = {
      id: Date.now(),
      role: "user",
      content: prompt
    };

    const assistantMessage = {
      id: Date.now() + 1,
      role: "assistant",
      content: generateResponse(prompt, profileData)
    };

    setMessages((current) => [...current, userMessage, assistantMessage]);
    setInput("");
  };

  const onSubmit = (event) => {
    event.preventDefault();
    sendQuestion(input);
  };

  return (
    <main className="page-shell">
      <section className="intro-panel">
        <p className="eyebrow">Portfolio</p>
        <img
          className="profile-photo"
          src="/profile.jpg"
          alt="Profile"
        />
        <h1>{profileData.name}</h1>
        <p className="headline">{profileData.headline}</p>
        <p className="bio">{profileData.bio}</p>

        <div className="meta-grid">
          <article>
            <h2>Top Skills</h2>
            <p>{profileData.skills.slice(0, 6).join(" • ")}</p>
          </article>
          <article>
            <h2>Contact</h2>
            <p>{profileData.contact.email}</p>
            <p>{profileData.contact.location}</p>
          </article>
        </div>
      </section>

      <section className="chat-panel" aria-label="Portfolio chat">
        <header className="chat-header">
          <h2>Ask about my work</h2>
          <p>Responses are generated only from local portfolio data.</p>
        </header>

        <div className="quick-actions" aria-label="Suggested questions">
          {quickQuestions.map((question) => (
            <button
              key={question}
              type="button"
              className="chip"
              onClick={() => sendQuestion(question)}
            >
              {question}
            </button>
          ))}
        </div>

        <div className="chat-log" role="log" aria-live="polite">
          {messages.map((message) => (
            <article key={message.id} className={`message ${message.role}`}>
              <p>{message.content}</p>
            </article>
          ))}
        </div>

        <form className="composer" onSubmit={onSubmit}>
          <label htmlFor="question" className="sr-only">
            Ask a question about profile data
          </label>
          <input
            id="question"
            value={input}
            onChange={(event) => setInput(event.target.value)}
            placeholder="Ask about experience, projects, skills, contact..."
          />
          <button type="submit">Send</button>
        </form>
      </section>
    </main>
  );
}

export default App;
